import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <a href="/" className="flex items-center space-x-2">
              <div className="w-10 h-10 flex items-center justify-center">
                <img src="https://static.readdy.ai/image/d59b18a86b2c4da172af70cd0d419253/e7f50c5a512809dd1b1927e02624ebd4.png" alt="Freeworkers Logo" className="w-full h-full object-contain" />
              </div>
              <span className={`text-lg font-bold transition-colors ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}>Freeworkers</span>
            </a>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <a href="#services" className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>서비스</a>
            <a href="#features" className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>주요 기능</a>
            <a href="#cases" className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}>고객 사례</a>
            <a href="#contact" className="bg-teal-500 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-teal-600 transition-colors whitespace-nowrap">
              문의하기
            </a>
          </div>

          <button 
            className="md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-6 py-4 space-y-3">
            <a href="#services" className="block text-sm font-medium text-gray-700 hover:text-teal-500">서비스</a>
            <a href="#features" className="block text-sm font-medium text-gray-700 hover:text-teal-500">주요 기능</a>
            <a href="#cases" className="block text-sm font-medium text-gray-700 hover:text-teal-500">고객 사례</a>
            <a href="#contact" className="block bg-teal-500 text-white px-6 py-2.5 rounded-lg text-sm font-medium text-center">
              문의하기
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
